// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

import type { CapabilityVideo } from "@dsbunny/capdb-schema";
import { kVideoCanvases } from "./canvases.js";

export async function videoDecodingInfo(): Promise<Array<CapabilityVideo>> {
	if(!('mediaCapabilities' in navigator)) {
		throw new Error('MediaCapabilities API not available');
	}
        const capabilities: Array<CapabilityVideo> = [];
	for(const canvas of kVideoCanvases) {
		for(const configuration of canvas.configurations) {
			let is_supported = false;
			let is_smooth = false;
			let is_power_efficient = false;
			try {
				const result = await navigator.mediaCapabilities.decodingInfo({
					type: "file",
					video: {
						contentType: `${configuration.mimeType}; codecs="${configuration.codec}"`,
						width: canvas.width,
						height: canvas.height,
						bitrate: 10000,
						framerate: canvas.framerate,
						hasAlphaChannel: canvas.hasAlphaChannel,
						hdrMetadataType: configuration.hdrMetadataType,
						colorGamut: configuration.colorGamut,
						transferFunction: configuration.transferFunction,
					},
				});
				is_supported = result.supported;
				is_smooth = result.smooth;
				is_power_efficient = result.powerEfficient;
			} catch {
				// Ignore errors
			}
			const capability: CapabilityVideo = {
				mime_type: 'video',
				mime_subtype: configuration.mimeType.split('/')[1],
				codec: configuration.codec,
				width: canvas.width,
				height: canvas.height,
				frame_rate: canvas.framerate,
				is_supported,
				is_smooth,
				is_power_efficient,
			};
			capabilities.push(capability);
		}
	}
	return capabilities;
}
